import axios from 'axios';

const exploreEndpoint = '/api/explore';

export const fetchFeaturedWorks = async (skip = 0, take = 3, type = 'featured') => {
  try {
    const response = await axios.get(exploreEndpoint, {
      params: {
        skip,
        take,
        type,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching featured works:', error);
    return [];
  }
};

export const getActiveListings = async (type = 'featured', quantity = 0) => {
  try {
    const response = await axios.get(`/api/listings/${type}/${quantity}`, {
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching active listings:', error);
    return [];
  }
}